export default __webpack_public_path__ + "static/white-cups-84f113c75d4b1842383f94c0b5539cf2.png";